import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ApprovalFlowSuccessor} from './approval-flow-successor.model';
import * as ApprovalFlowSuccessorActions from './approval-flow-successor.actions';

export const approvalFlowSuccessorsFeatureKey = 'approvalFlowSuccessors';

export interface State extends EntityState<ApprovalFlowSuccessor> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ApprovalFlowSuccessor> = createEntityAdapter<ApprovalFlowSuccessor>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ApprovalFlowSuccessorActions.addApprovalFlowSuccessor,
    (state, action) => adapter.addOne(action.approvalFlowSuccessor, state)
  ),
  on(ApprovalFlowSuccessorActions.upsertApprovalFlowSuccessor,
    (state, action) => adapter.upsertOne(action.approvalFlowSuccessor, state)
  ),
  on(ApprovalFlowSuccessorActions.addApprovalFlowSuccessors,
    (state, action) => adapter.addMany(action.approvalFlowSuccessors, state)
  ),
  on(ApprovalFlowSuccessorActions.upsertApprovalFlowSuccessors,
    (state, action) => adapter.upsertMany(action.approvalFlowSuccessors, state)
  ),
  on(ApprovalFlowSuccessorActions.updateApprovalFlowSuccessor,
    (state, action) => adapter.updateOne(action.approvalFlowSuccessor, state)
  ),
  on(ApprovalFlowSuccessorActions.updateApprovalFlowSuccessors,
    (state, action) => adapter.updateMany(action.approvalFlowSuccessors, state)
  ),
  on(ApprovalFlowSuccessorActions.deleteApprovalFlowSuccessor,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ApprovalFlowSuccessorActions.deleteApprovalFlowSuccessors,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ApprovalFlowSuccessorActions.loadApprovalFlowSuccessors,
    (state, action) => adapter.setAll(action.approvalFlowSuccessors, state)
  ),
  on(ApprovalFlowSuccessorActions.clearApprovalFlowSuccessors,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
